import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class PaysheetManager{
  
  calculate(paysheet:any[]) : any {
    let data = [];
    let totalFinal = 0;
    let totalViajes = 0;
    let totalAumentos = 0;
    let totalDescuentos = 0;

    if (paysheet.length) {
      let driver_id = paysheet[0].driver_id;
      let info = [];
      let total = 0;
      let totalSuma = 0;
      let totalResta = 0;

      for(let i = 0; i < paysheet.length; i++) {
        if (paysheet[i].in_cash) {
          if (driver_id != paysheet[i].driver_id) {
            data.push({info: info, totals: {total, totalSuma, totalResta}});
            info = [];
            total = 0;
            totalSuma = 0;
            totalResta = 0;
            driver_id = paysheet[i].driver_id;
          }
          info.push(paysheet[i]);
          total += paysheet[i].expense_type_name ? paysheet[i].pay*-1 : paysheet[i].price*1;
          totalFinal += paysheet[i].expense_type_name ? paysheet[i].pay*-1 : paysheet[i].price*1;
          totalSuma += paysheet[i].expense_type_name ? 0 : paysheet[i].price*1;
          totalResta += paysheet[i].expense_type_name ? paysheet[i].pay*-1 : 0;
          totalViajes += paysheet[i].travel_id ? paysheet[i].price*1 : 0;
          totalAumentos += !paysheet[i].expense_type_name && !paysheet[i].travel_id ? paysheet[i].price*1 : 0;
          totalDescuentos += paysheet[i].expense_type_name ? paysheet[i].pay*1 : 0;
        }
      }

      data.push({info: info, totals: {total, totalSuma, totalResta}});
    }

    return {data: data.filter(x => x.info.length), total: totalFinal, totalViajes, totalAumentos, totalDescuentos};
  }
}